import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ComingSoonComponent } from './core/components/coming-soon/coming-soon.component';
// import { AuthCoverLoginComponent } from './auth/auth-cover-login/auth-cover-login.component';
// import { AuthCoverRePasswordComponent } from './auth/auth-cover-re-password/auth-cover-re-password.component';
// import { AuthCoverSignupComponent } from './auth/auth-cover-signup/auth-cover-signup.component';
// import { AuthLoginThreeComponent } from './auth/auth-login-three/auth-login-three.component';
// import { AuthLoginComponent } from './auth/auth-login/auth-login.component';
// import { AuthRePasswordThreeComponent } from './auth/auth-re-password-three/auth-re-password-three.component';
// import { AuthRePasswordComponent } from './auth/auth-re-password/auth-re-password.component';
// import { AuthSignupThreeComponent } from './auth/auth-signup-three/auth-signup-three.component';
// import { AuthSignupComponent } from './auth/auth-signup/auth-signup.component';

// import { ChangelogComponent } from './core/components/changelog/changelog.component';

// import { DocumentationComponent } from './core/components/documentation/documentation.component';
// import { ForumsTopicComponent } from './core/components/forums-topic/forums-topic.component';
// import { IndexBlogComponent } from './core/components/index-blog/index-blog.component';
// import { IndexCarRidingComponent } from './core/components/index-car-riding/index-car-riding.component';
// import { IndexCourseComponent } from './core/components/index-course/index-course.component';
// import { IndexOnlineLearningComponent } from './core/components/index-online-learning/index-online-learning.component';
// import { IndexServicesComponent } from './core/components/index-services/index-services.component';

// import { MasterPageComponent } from './core/components/master-page/master-page.component';



// import { WidgetComponent } from './core/components/widget/widget.component';
// import { EmailAlertComponent } from './email/email-alert/email-alert.component';
// import { EmailConfirmationComponent } from './email/email-confirmation/email-confirmation.component';
// import { EmailInvoiceComponent } from './email/email-invoice/email-invoice.component';
// import { EmailPasswordResetComponent } from './email/email-password-reset/email-password-reset.component';
// import { SwitcherComponent } from './shared/switcher/switcher.component';

const routes: Routes = [
  { path: '', component: ComingSoonComponent },
  { path: '**', redirectTo: '' },
  /*
  {
    path: '',
    component: MasterPageComponent,
    children: [
      { path: '', component: IndexOnlineLearningComponent },
      // { path: 'account-messages', component: AccountMessagesComponent },
      // { path: 'account-members', component: AccountMembersComponent },
      // { path: 'account-payments', component: AccountPaymentsComponent },
      // { path: 'account-profile', component: AccountProfileComponent },
      // { path: 'account-setting', component: AccountSettingComponent },
      // { path: 'account-works', component: AccountWorksComponent },
      { path: 'privacy', component: ChangelogComponent },
      // { path: 'components', component: ComponentsComponent },
      { path: 'aboutus', component: DocumentationComponent },
      // { path: 'forums', component: ForumsComponent },
      // { path: 'forums-comments', component: ForumsCommentsComponent },
      { path: 'termsconditions', component: ForumsTopicComponent },
      // { path: 'helpcenter-faqs', component: HelpcenterFaqsComponent },
      // { path: 'helpcenter-guides', component: HelpcenterGuidesComponent },
      // { path: 'helpcenter-overview', component: HelpcenterOverviewComponent },
      // { path: 'helpcenter-support-request', component: HelpcenterSupportRequestComponent },
      // { path: 'index', component: IndexComponent },
      // { path: 'index-agency', component: IndexAgencyComponent },
      // { path: 'index-apps', component: IndexAppsComponent },
      { path: 'teachers', component: IndexBlogComponent },
      // { path: 'index-business', component: IndexBusinessComponent },
      { path: 'education-institutions', component: IndexCarRidingComponent },
      // { path: 'index-classic-app', component: IndexClassicAppComponent },
      // { path: 'index-classic-saas', component: IndexClassicSaasComponent },
      // { path: 'index-corporate', component: IndexCorporateComponent },
      { path: 'students', component: IndexCourseComponent },
      // { path: 'index-coworking', component: IndexCoworkingComponent },
      // { path: 'index-crypto', component: IndexCryptoComponent },
      // { path: 'index-customer', component: IndexCustomerComponent },
      // { path: 'index-digital-agency', component: IndexDigitalAgencyComponent },
      // { path: 'index-ebook', component: IndexEbookComponent },
      // { path: 'index-email-inbox', component: IndexEmailInboxComponent },
      // { path: 'index-enterprise', component: IndexEnterpriseComponent },
      // { path: 'index-event', component: IndexEventComponent },
      // { path: 'index-hosting', component: IndexHostingComponent },
      // { path: 'index-hotel', component: IndexHotelComponent },
      // { path: 'index-insurance', component: IndexInsuranceComponent },
      // { path: 'index-it-solution', component: IndexItSolutionComponent },
      // { path: 'index-job', component: IndexJobComponent },
      // { path: 'index-landing-one', component: IndexLandingOneComponent },
      // { path: 'index-landing-three', component: IndexLandingThreeComponent },
      // { path: 'index-landing-two', component: IndexLandingTwoComponent },
      // { path: 'index-marketing', component: IndexMarketingComponent },
      // { path: 'index-modern-business', component: IndexModernBusinessComponent },

      // { path: 'index-online-learning', component: IndexOnlineLearningComponent },
      // { path: 'index-payments', component: IndexPaymentsComponent },
      // { path: 'index-personal', component: IndexPersonalComponent },
      // { path: 'index-portfolio', component: IndexPortfolioComponent },
      // { path: 'index-saas', component: IndexSaasComponent },
      { path: 'corporates', component: IndexServicesComponent },
      // { path: 'index-shop', component: IndexShopComponent },
      // { path: 'index-single-product', component: IndexSingleProductComponent },
      // { path: 'index-social-marketing', component: IndexSocialMarketingComponent },
      // { path: 'index-software', component: IndexSoftwareComponent },
      // { path: 'index-studio', component: IndexStudioComponent },
      // { path: 'index-task-management', component: IndexTaskManagementComponent },
      // { path: 'index-travel', component: IndexTravelComponent },
      // { path: 'page-aboutus', component: PageAboutusComponent },
      // { path: 'page-aboutus-two', component: PageAboutusTwoComponent },
      // { path: 'page-blog-detail', component: PageBlogDetailComponent },
      // { path: 'page-blog-grid', component: PageBlogGridComponent },
      // { path: 'page-blog-list', component: PageBlogListComponent },
      // { path: 'page-blog-list-sidebar', component: PageBlogListSidebarComponent },
      // { path: 'page-blog-sidebar', component: PageBlogSidebarComponent },
      // { path: 'page-case-detail', component: PageCaseDetailComponent },
      // { path: 'page-cases', component: PageCasesComponent },
      // { path: 'page-contact-detail', component: PageContactDetailComponent },
      // { path: 'page-contact-one', component: PageContactOneComponent },
      // { path: 'page-contact-three', component: PageContactThreeComponent },
      // { path: 'page-contact-two', component: PageContactTwoComponent },
      // { path: 'page-history', component: PageHistoryComponent },
      // { path: 'page-invoice', component: PageInvoiceComponent },
      // { path: 'page-job-apply', component: PageJobApplyComponent },
      // { path: 'page-job-candidate', component: PageJobCandidateComponent },
      // { path: 'page-job-company', component: PageJobCompanyComponent },
      // { path: 'page-job-detail', component: PageJobDetailComponent },
      // { path: 'page-jobs', component: PageJobsComponent },
      // { path: 'page-jobs-sidebar', component: PageJobsSidebarComponent },
      // { path: 'page-pricing', component: PagePricingComponent },
      // { path: 'page-privacy', component: PagePrivacyComponent },
      // { path: 'page-services', component: PageServicesComponent },
      // { path: 'page-team', component: PageTeamComponent },
      // { path: 'page-terms', component: PageTermsComponent },
      // { path: 'page-work-classic', component: PageWorkClassicComponent },
      // { path: 'page-work-detail', component: PageWorkDetailComponent },
      // { path: 'page-work-grid', component: PageWorkGridComponent },
      // { path: 'page-work-masonry', component: PageWorkMasonryComponent },
      // { path: 'page-work-modern', component: PageWorkModernComponent },
      // { path: 'shop-cart', component: ShopCartComponent },
      // { path: 'shop-checkouts', component: ShopCheckoutsComponent },
      // { path: 'shop-myaccount', component: ShopMyaccountComponent },
      // { path: 'shop-product-detail', component: ShopProductDetailComponent },
      // { path: 'shop-products', component: ShopProductsComponent },
      { path: 'contact', component: WidgetComponent },
      // { path: 'page-blog-detail-two', component: PageBlogDetailTwoComponent },
      // { path: '#', component: SwitcherComponent },
    ]
  },

  { path: 'auth-login', component: AuthLoginComponent },
  { path: 'auth-cover-login', component: AuthCoverLoginComponent },
  { path: 'auth-cover-re-password', component: AuthCoverRePasswordComponent },
  { path: 'auth-cover-signup', component: AuthCoverSignupComponent },
  { path: 'auth-login-three', component: AuthLoginThreeComponent },
  { path: 'auth-re-password', component: AuthRePasswordComponent },
  { path: 'auth-re-password-three', component: AuthRePasswordThreeComponent },
  { path: 'auth-signup', component: AuthSignupComponent },
  { path: 'auth-signup-three', component: AuthSignupThreeComponent },


  { path: 'email-alert', component: EmailAlertComponent },
  { path: 'email-confirmation', component: EmailConfirmationComponent },
  { path: 'email-invoice', component: EmailInvoiceComponent },
  { path: 'email-password-reset', component: EmailPasswordResetComponent },
  */

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
